module.exports = __webpack_public_path__ + "static/media/STEM_orders1@3x.96c9f2c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/STEM_orders1@3x.png
// module id = 761
// module chunks = 0